export default function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".syncErrors") || empty;
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/selectors/getFormSyncErrors.js
// module id = 1347
// module chunks = 25